









































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
// import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import DateFormat from "@/utility/DateFormat";
// import CardModalTtd from "@/components/modal/CardModalTtd.vue";

@Component({
  components: {
    // CardModalTtd,
  }
})
export default class BaseCardSuket extends Vue {
  @Prop() readonly register!: string;
  @Prop() expandInput!: boolean;
  @Prop() loading!: boolean;
  @Prop() creatorUserId!: number | string;
  @Prop() signeeUserId!: number | string;
  @Prop() contentData!: Record<string, unknown>;
  @Prop() title!: string;
  @Prop({ default: false }) isReadOnly: boolean;
  @Prop() instantCreate = false;
  @Prop() isCanCreate: boolean;
  @Prop() isCanEdit: boolean;
  @Prop() isCanRemove: boolean;
  @Prop() isCanSign: boolean;

  modalTtd = false;
  pageTab = "tab-soap";
  isBusy = false;

  get statesoapdetail() {
    // return storeSoap.detailSoap;
    return [1, 2];
  }

  get user() {
    return userModule.user;
  }

  get canEdit() {
    const defaultRule = [
      this.creatorUserId.toString(),
      this.signeeUserId.toString()
    ].includes(this.user.id.toString());

    return this.isCanEdit !== undefined ? this.isCanEdit : defaultRule;
  }

  get canSign() {
    const defaultRule =
      this.user.id == this.signeeUserId && !this.contentData.signed_at;

    return this.isCanSign !== undefined ? this.isCanSign : defaultRule;
  }

  get canRemove() {
    const defaultRule = [
      this.creatorUserId.toString(),
      this.signeeUserId.toString()
    ].includes(this.user.id.toString());

    return this.isCanRemove !== undefined ? this.isCanRemove : defaultRule;
  }

  get canCreate() {
    const defaultRule = this.user.profesi === "Dokter";

    return this.isCanCreate !== undefined ? this.isCanCreate : defaultRule;
  }

  get signedDateTime() {
    return this.contentData.signed_at
      ? DateFormat.formatDate(this.contentData.signed_at)
      : null;
  }

  backPageSoap() {
    this.$emit("backPageSoap");
  }

  print() {
    this.$emit("print", this.contentData.id);
  }

  edit() {
    this.$emit("showInput");
  }

  createSuketInstant() {
    this.$emit("createSuket");
  }

  remove() {
    const q = confirm(`Hapus ${this.title} ini?`);

    if (q) {
      this.$emit("removeSuket");
    }
  }

  showSignatureModal() {
    this.$emit("showSignatureModal");
  }
}
